import React, { ReactNode } from "react";

import { faPlus } from "@fortawesome/pro-solid-svg-icons/faPlus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import cn from "classnames";
import { IntlShape } from "react-intl";

import styles from "./customOptionRenderer.module.scss";

const customOptionRenderer =
  (intl: IntlShape, label: ReactNode, onClick?: () => void, disabled?: boolean) =>
  (menu: ReactNode) => {
    const customOption = (
      <div
        className={cn(styles.customOption, { [styles.disabled]: !!disabled })}
        onClick={disabled ? undefined : onClick}
      >
        {intl.formatMessage(
          {
            id: "map.toolbar.popovers.pinSettings.legendDropdown.customOption",
            defaultMessage: "{icon} {label}",
            description:
              "Layout of the custom option in legend dropdowns in Pin Settings popover on the map page",
          },
          {
            icon: <FontAwesomeIcon icon={faPlus} />,
            label,
          }
        )}
      </div>
    );

    return (
      <>
        {disabled ? (
          <Tooltip
            placement="right"
            title={intl.formatMessage({
              id: "map.toolbar.popovers.pinSettings.legendDropdown.customOptionDisabled",
              defaultMessage: "Exit Lead Finder to Create Custom",
              description: "Exit Lead Finder to Create Custom",
            })}
          >
            {customOption}
          </Tooltip>
        ) : (
          customOption
        )}
        {menu}
      </>
    );
  };

export default customOptionRenderer;
